import { createSelector } from "reselect";
import { config as selectConfig } from "../state/config/config.selector";
import {
  selectDashboardDetails,
  selectStoredSearchParams,
} from "../state/workspaces/workspaces.selector";
import { getWorkspaceURL } from "../utils/url.helpers";

export const selectLiveWorkspaces = createSelector(
  [selectConfig, selectDashboardDetails, selectStoredSearchParams],
  (config, dashboardDetails, storedSearchParams) => {
    return Object.entries(dashboardDetails.workspaceDetails)
      .filter(([, details]) => details.isLive)
      .map(([workspaceId, workspaceDetail]) => ({
        workspaceId,
        workspaceUrl: getWorkspaceURL(
          workspaceDetail.workspaceType,
          workspaceId,
          config,
          workspaceDetail.workspaceModuleName ?? "",
          storedSearchParams,
        ),
        isFullscreen: workspaceId === dashboardDetails.fullscreenWorkspaceId,
      }));
  },
);
